export default __webpack_public_path__ + "static/media/ic-bought-coin.614ed1dc.svg";